// eslint-disable-next-line max-len
const colorWallQuery = `query PaintColorFamily($colorFamily: String, $navbarindex: Int, $channel: Channel, $vendor: String){
    paint(colorfamily: $colorFamily, navbarindex: $navbarindex, channel:$channel, vendor: $vendor) {
      searchReport {
        numberOfColumns
        totalColors
        totalNavBarColors
        colorFamily
      }
      breadCrumbs {
        label
        dimensionName
        url
      }
      navBars {
        navBarIndex
        colorName
        rgb
        selected
      }
    dimensions {
      label
      refinements {
        label
        refinementKey
        selected
      }
    }
      colors {
        colorNumber
        vendor
        colorName
        rgb
      }
    }
  }`;

const colorDetailsQuery = `query PaintColorDetails($colorNumber: String!, $vendor: String!, $channel: Channel){
    paintColorDetails(colornumber: $colorNumber, vendor: $vendor, channel:$channel) {
    similarColors {
      colorNumber
      vendor
      colorName
      rgb
      isAnchor
    }
    coordinatingColors {
      colorNumber
      vendor
      colorName
      rgb
      isAnchor
    }
    topSellers {
      itemId
      canonicalURL
    }
    sample {
      itemId
      canonicalURL
    }
    color {
      colorNumber
      vendor
      colorName
      rgb
      isAnchor
    }
  }
}`;

export const getUrlData = (url) => {
  let splitPathname = url.split('/');
  let color = splitPathname?.[3] || 'popular';
  let navBarIndex;
  let brand;
  if (splitPathname[4] === 'Behr' || splitPathname[4] === 'PPG%20-%20Glidden') {
    navBarIndex = null;
    brand = splitPathname?.[4] || null;
  } else {
    navBarIndex = splitPathname?.[4] || null;
    brand = splitPathname?.[5] || null;
  }

  if (splitPathname.includes('render-nucleus')) {
    color = splitPathname?.[4];
    navBarIndex = splitPathname?.[5] || null;
    brand = splitPathname?.[6] || null;
  }
  if (brand) {
    brand = decodeURI(brand);
  }
  return {
    color,
    navBarIndex,
    brand
  };
};

export const getSearchParams = (url) => {
  const urlParams = new URLSearchParams(url);
  const colorNumber = urlParams?.get('colorNumber');
  const brandName = decodeURI(urlParams?.get('brand')) !== 'null' ? decodeURI(urlParams.get('brand')) : null;
  return {
    colorNumber,
    brandName
  };
};

const cacheKey = ({ url: requestURL, hashCode }) => {
  try {
    const { pathname } = new URL(requestURL);
    return `${pathname}:${hashCode}`;
  } catch (error) {
    return `${requestURL}:${hashCode}`;
  }
};

// IF NO DATA GETS RETURNED, RETURN ERROR PAGE
export const getDataObject = async (system, color, navBarIndex, brand, colorNumber, brandName) => {
  let postResponse;
  let dataObject;

  let url = system.host
    ? `${system?.data?.hosts?.api}/SearchNav/v2/search/paint/model`
    : '/SearchNav/v2/search/paint/model';

  const channel = (system?.data
    ? system?.data?.requestData?.channel?.toUpperCase()
    : system?.expContext?.experienceContext?.channel?.toUpperCase()) || 'DESKTOP';

  if ((!colorNumber && !(brandName || brand)) || (brandName && (!colorNumber && !brand))) {
    postResponse = await system.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        variables: {
          colorFamily: color,
          channel,
          navbarindex: parseInt(navBarIndex, 10),
          vendor: brandName || brand
        },
        query: colorWallQuery
      })
    }, cacheKey);
  } else {
    const colorDetailsData = await system.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        variables: {
          colorNumber,
          channel,
          vendor: brandName || brand
        },
        query: colorDetailsQuery
      })
    }, cacheKey);
    const colorWallData = await system.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        variables: {
          colorFamily: color,
          channel,
          navbarindex: parseInt(navBarIndex, 10),
          vendor: brandName || brand
        },
        query: colorWallQuery
      })
    }, cacheKey);
    postResponse = await Promise.all([colorDetailsData, colorWallData]);
  }

  if (postResponse?.[0] && postResponse?.[1]) {
    dataObject = {
      colorDetailsData: {
        colorBrand: brandName || brand,
        colorDetailsData:
        {
          ...postResponse[0].data?.paintColorDetails,
          ...postResponse[0].data?.paintColorDetails.color,
          colorBrand: postResponse[0].data?.paintColorDetails?.color?.vendor,
          coordinatingColors: postResponse[0].data?.paintColorDetails?.coordinatingColors?.map((colorData) => {
            return {
              ...colorData,
              colorBrand: colorData?.vendor
            };
          }),
          similarColors: postResponse[0].data?.paintColorDetails?.similarColors?.map((colorData) => {
            return {
              ...colorData,
              colorBrand: colorData.vendor
            };
          }),
        } || {},
        colorNumber,
        ...postResponse[0].variables,
      },
      colorWallData: {
        colorFamily: color,
        colorWallData: postResponse[1].data?.paint,
        ...postResponse[1].variables,
      }
    };
  } else {
    dataObject = {
      colorDetailsData: {},
      colorWallData: {
        ...postResponse?.variables,
        colorFamily: color,
        colorWallData: postResponse?.data?.paint,
      }
    };
  }
  return dataObject;
};